import axios from 'axios';
class VideoService {
    async getVideoListWithSorting(page, limit = 25, sortBy = 'viewCount', sortOrder = 'DESC') {
        const params = {
            page,
            limit,
            sortBy,
            sortOrder
        };

        return await axios.get(`${process.env.REACT_APP_API_URL}/api/videos/list`, {
            params: params,
            headers: {
                "X-API-KEY": process.env.REACT_APP_API_KEY,
                "Content-Type": "application/json"
            },
        }).then(response => {
            return {
                items: response.data.items || [],
                pagination: {
                    page: response.data.page || 1,
                    limit: response.data.limit || 25,
                    totalPages: response.data.total_pages || 1,
                    totalItems: response.data.total_items || 0
                },
                criteria: response.data.criteria || {}
            };
        }).catch(error => {
            console.error('Error in getVideoListWithSorting:', error);
            throw error;
        });
    }

    async getVideoList(page, countryCode, trackedAt, onlyNew) {
        const params = {page};

        if (countryCode) {
            params.countryCode = countryCode;
        }

        if (trackedAt) {
            params.trackedAt = trackedAt;
        }

        if (onlyNew) {
            params.onlyNew = true;
        }

        return await axios.get(`${process.env.REACT_APP_API_URL}/api/videos`, {
            params: params,
            headers: {
                "X-API-KEY": process.env.REACT_APP_API_KEY,
                "Content-Type": "application/json"
            },
        }).then(response => {
            const processedItems = response.data.items.map(video => {
                video.countriesWithPositions = video.countriesWithPositions.split(', ').map(item => {
                    const [code, value] = item.split(':');

                    return {code, value};
                });

                return video;
            });

            return {
                items: processedItems,
                pagination: {
                    page: response.data.page,
                    limit: response.data.limit,
                    totalPages: response.data.total_pages,
                    totalItems: response.data.total_items
                }
            };
        });
    }

    async getVideoDetail(videoId) {
        return await axios.get(`${process.env.REACT_APP_API_URL}/api/videos/${videoId}`, {
            headers: {
                "X-API-KEY": process.env.REACT_APP_API_KEY,
                "Content-Type": "application/json"
            },
        }).then(response => response.data);
    }
}

const videoService = new VideoService();
export default videoService;